/**
 * Shrink wrapped link-list buttons to their text (QA Mobile / Interior #2).
 *
 * An inline-flex button whose label wraps keeps its pre-wrap width — the text
 * sits on two short lines inside a full-column box, which reads as huge side
 * padding ("Working in Federal Government" on phones). CSS can't shrink a box
 * to its wrapped line boxes, so measure the widest rendered line and pin the
 * button's width to it. Setting width = widest line keeps the same break
 * points (every existing line still fits), so this never adds a third line.
 */
export default function initFitButtons() {
	const buttons = document.querySelectorAll('.link-list__link');
	if (!buttons.length) return;

	const fit = (el) => {
		el.style.removeProperty('inline-size');

		const range = document.createRange();
		range.selectNodeContents(el);
		const lines = [...range.getClientRects()].filter((r) => r.width > 0);
		if (lines.length < 2) return; // single line already hugs

		const cs = getComputedStyle(el);
		const extra =
			parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) +
			parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
		const widest = Math.max(...lines.map((r) => r.width));
		el.style.inlineSize = `${Math.ceil(widest + extra) + 1}px`;
	};

	const fitAll = () => buttons.forEach(fit);

	// Fonts change line breaks, and the hosted webfont kits (cloud.typography
	// data-URI faces) can land after document.fonts.ready resolves — so fit
	// now, after the fonts promise, after window load, and once more shortly
	// after, taking whichever layout is current. fit() re-measures from the
	// natural width each time, so repeat runs self-correct.
	fitAll();
	document.fonts?.ready?.then(fitAll);
	window.addEventListener('load', () => {
		fitAll();
		setTimeout(fitAll, 600);
	});

	let timer;
	window.addEventListener('resize', () => {
		clearTimeout(timer);
		timer = setTimeout(fitAll, 150);
	});
}
